var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSticker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.4,
    height: 10.401,
    viewBox: "0 0 10.4 10.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4,11.2H3.6A2.8,2.8,0,0,1,.8,8.4V3.6A2.8,2.8,0,0,1,3.6.8H8.4a2.8,2.8,0,0,1,2.8,2.8V6.4H9.992A3.629,3.629,0,0,0,6.4,9.993V11.2Zm.8-.073V9.993A2.817,2.817,0,0,1,9.992,7.2h1.136A7.842,7.842,0,0,1,7.2,11.128Z",
    transform: "translate(-0.8 -0.8)",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker);
export default __webpack_public_path__ + "static/media/sticker.7fc263a4a8c121e6e5e50e22f44abea9.svg";
export { ForwardRef as ReactComponent };